import { cn } from "@/lib/utils";

export default function BrandLogo({ size = "md", className, alt = "Adl" }) {
  const sizes = {
    sm: "w-8 h-8",
    md: "w-9 h-9",
    lg: "w-12 h-12",
    xl: "w-16 h-16",
  };

  return (
    <img
      src={`${process.env.PUBLIC_URL}/logo.png`}
      alt={alt}
      className={cn("object-contain shrink-0", sizes[size] || sizes.md, className)}
    />
  );
}
